module.exports = __webpack_public_path__ + "img/3-5.347217a2.png";